import { render, staticRenderFns } from "./MenuTopIcon.vue?vue&type=template&id=c1883a48&scoped=true"
import script from "./MenuTopIcon.vue?vue&type=script&lang=js"
export * from "./MenuTopIcon.vue?vue&type=script&lang=js"
import style0 from "./MenuTopIcon.vue?vue&type=style&index=0&id=c1883a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1883a48",
  null
  
)

export default component.exports